/// <reference types="vite-plugin-svgr/client" />

import Appearance from './Appearance.svg?react';
import Armory from './Armory.svg?react';
import Back from './Back.svg?react';
import Burst from './Burst.svg?react';
import Coin from './Coin.svg?react';
import Coins from './Coins.svg?react';
import Craftable from './Craftable.svg?react';
import Dice from './Dice.svg?react';
import DogPaw from './DogPaw.svg?react';
import Drumstick from './Drumstick.svg?react';
import Edit from './Edit.svg?react';
import Face from './Face.svg?react';
import Fire from './Fire.svg?react';
import Friends from './Friends.svg?react';
import Gear from './Gear.svg?react';
import Home from './Home.svg?react';
import HouseLock from './HouseLock.svg?react';
import Info from './Info.svg?react';
import ItemBox from './ItemBox.svg?react';
import Logout from './Logout.svg?react';
import Luck from './Luck.svg?react';
import Map from './Map.svg?react';
import Marker from './Marker.svg?react';
import Medal from './Medal.svg?react';
import Monster from './Monster.svg?react';
import Music from './Music.svg?react';
import News from './News.svg?react';
import Paintball from './Paintball.svg?react';
import Party from './Party.svg?react';
import Paw from './Paw.svg?react';
import Potion from './Potion.svg?react';
import Pulse from './Pulse.svg?react';
import QR from './QR.svg?react';
import Quest from './Quest.svg?react';
import Question from './Question.svg?react';
import Refresh from './Refresh.svg?react';
import Shop from './Shop.svg?react';
import Spin from './Spin.svg?react';
import Star from './Star.svg?react';
import StarYellow from './StarYellow.svg?react';
import Sword from './Sword.svg?react';
import Trash from './Trash.svg?react';
import Tree from './Tree.svg?react';
import Warning from './Warning.svg?react';
import X from './X.svg?react';

export const icons_old = {
  Appearance,
  Armory,
  Back,
  Burst,
  Coin,
  Coins,
  Craftable,
  Dice,
  DogPaw,
  Drumstick,
  Edit,
  Face,
  Fire,
  Friends,
  Gear,
  Home,
  HouseLock,
  Info,
  ItemBox,
  Logout,
  Luck,
  Map,
  Marker,
  Medal,
  Monster,
  Music,
  News,
  Paintball,
  Party,
  Paw,
  Potion,
  Pulse,
  QR,
  Quest,
  Question,
  Refresh,
  Shop,
  Spin,
  Star,
  StarYellow,
  Sword,
  Trash,
  Tree,
  Warning,
  X,
};
